<template>
  <div class="account-deleted">
    <div class="box">
      <div class="text">
        <div class="title">
          <h2>{{ title }}</h2>
        </div>
        <div class="description">
          <span v-html="description"></span>
        </div>
      </div>
      <router-link :to="{ name: 'top-lp' }">
        <button class="secondary">{{ $t('accountDeletedPage.backToTop') }}</button>
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend<{}, {}, Computed, {}>({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  computed: {
    title() {
      return this.$t('accountDeletedPage.title');
    },
    description() {
      return this.$t('accountDeletedPage.description');
    },
  },
});

interface Computed {
  title: string;
  description: string;
}
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";
.account-deleted {
  height: calc(100vh - #{$header-height});
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-text-normal);
  background-color: var(--color-background-normal);
  box-sizing: border-box;
  padding: 50px;

  .box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--color-surface-subtle);
    box-sizing: border-box;
    border-radius: var(--radius-lg);
    padding: 50px 100px;

    @include mq(sp) {
      max-width: calc(100vw * 0.8);
      padding: 30px 15px;
    }

    .text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 50px;
      max-width: 800px;

      .title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;

        h2 {
          margin: 0;
          white-space: pre-wrap;
          text-align: center;
          color: var(--color-text-normal);

          @include mq(sp) {
            font-size: var(--font-size-lg);
          }
        }
      }

      .description {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 1.25em;
        color: var(--color-text-normal);

        span {
          white-space: pre-wrap;
          text-align: center;
        }
      }
    }

    button {
      padding: 20px 50px;
      border-radius: var(--radius-rounded);
      border: none;
      font-size: var(--font-size-lg);
      font-weight: var(--font-weight-bold);
      color: var(--color-text-on-fixed-bg);
      cursor: pointer;

      &.secondary {
        background-color: var(--color-inactive);
      }
    }
  }
}
</style>
